var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8499 16.4401C17.9445 16.534 17.9978 16.6618 17.9978 16.7951C17.9978 16.9284 17.9445 17.0562 17.8499 17.1501L17.1499 17.8501C17.056 17.9448 16.9282 17.998 16.7949 17.998C16.6615 17.998 16.5337 17.9448 16.4399 17.8501L11.9999 13.4101L7.55985 17.8501C7.46597 17.9448 7.33817 17.998 7.20485 17.998C7.07153 17.998 6.94374 17.9448 6.84985 17.8501L6.14985 17.1501C6.0552 17.0562 6.00195 16.9284 6.00195 16.7951C6.00195 16.6618 6.0552 16.534 6.14985 16.4401L10.5899 12.0001L6.14985 7.5601C6.0552 7.46621 6.00195 7.33842 6.00195 7.2051C6.00195 7.07178 6.0552 6.94398 6.14985 6.8501L6.84985 6.1501C6.94374 6.05544 7.07153 6.0022 7.20485 6.0022C7.33817 6.0022 7.46597 6.05544 7.55985 6.1501L11.9999 10.5901L16.4399 6.1501C16.5337 6.05544 16.6615 6.0022 16.7949 6.0022C16.9282 6.0022 17.056 6.05544 17.1499 6.1501L17.8499 6.8501C17.9445 6.94398 17.9978 7.07178 17.9978 7.2051C17.9978 7.33842 17.9445 7.46621 17.8499 7.5601L13.4099 12.0001L17.8499 16.4401Z",
    fill: "#9A9CB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.d9f8f0de.svg";
export { ForwardRef as ReactComponent };